import { useDispatch } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';

import faqSlice from './slices/FaqSlice/FaqSlice';
import newsSlice from './slices/NewsSlice/NewsSlice';
import authSlice from './slices/AuthSlice/AuthSlice';
import promPaySlice from './slices/PromPaySlice/PromPaySlice';
import abonentSlice from './slices/AbonentSlice/AbonentSlice';
import setTarifSlice from './slices/SetTarifSlice/SetTarifSlice';
import voluntaryBlockSlice from './slices/BlockSlice/BlockSlice';
import tarifsListSlice from './slices/TarifsListSlice/TarifsListSlice';
import payHistorySlice from './slices/PayHistorySlice/PayHistorySlice';
import voluntaryUnblockSlice from './slices/UnblockSlice/UnblockSlice';
import setServiceSlice from './slices/SetServiceSlice/SetServiceSlice';
import postApplicationSlice from './slices/FeedbackSlice/FeedbackSlice';
import mainInfoSlice from './slices/MainPageInfoSlice/MainPageInfoSlice';
import editProfileSlice from './slices/EditProfileSlice/EditProfileSlice';
import authRecoverSlice from './slices/AuthRecoverSlice/AuthRecoverSlice';
import serviceListSlice from './slices/ServiceListSlice/ServiceListSlice';
import promPayListSlice from './slices/PromPayListSlice/PromPayListSlice';
import selectedItemSlice from './slices/SelectedItemSlice/SelectedItemSlice';
import currentTarifSlice from './slices/CurrentTarifSlice/CurrentTarifSlice';
import notificationSlice from './slices/NotificationSlice/NotificationSlice';
import removeServiceSlice from './slices/RemoveServiceSlice/RemoveServiceSlice';
import abonentSetedUslugasSlice from './slices/SetedUslugasSlice/SetedUslugasSlice';
import writeOffHistorySlice from './slices/WriteOffHistorySlice/WriteOffHistorySlice';
import changePasswordSlice from './slices/AuthChangePasswordSlice/AuthChangePasswordSlice';
import tarifChangeSlice from './slices/TarifChangeNotificationSlice/TarifChangeNotificationSlice';

const store = configureStore({
	reducer: {
		faq: faqSlice,
		auth: authSlice,
		news: newsSlice,
		abonent: abonentSlice,
		promPay: promPaySlice,
		mainInfo: mainInfoSlice,
		setTarif: setTarifSlice,
		recover: authRecoverSlice,
		block: voluntaryBlockSlice,
		setUsluga: setServiceSlice,
		payHistory: payHistorySlice,
		tarifsList: tarifsListSlice,
		editProfile: editProfileSlice,
		promPayList: promPayListSlice,
		serviceList: serviceListSlice,
		unblock: voluntaryUnblockSlice,
		currentTarif: currentTarifSlice,
		notification: notificationSlice,
		selectedItem: selectedItemSlice,
		removeUsluga: removeServiceSlice,
		application: postApplicationSlice,
		changePassword: changePasswordSlice,
		tarifNotification: tarifChangeSlice,
		writeOffHistory: writeOffHistorySlice,
		abonentSetedUslugas: abonentSetedUslugasSlice,
	},
});

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;

export type RootState = ReturnType<typeof store.getState>;

export default store;
